<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "routeIndex"
    }
</script>

<style scoped>

</style>
